module.exports = __webpack_public_path__ + "static/metal04-ca0531aaf1776834193922b2eee5277b.png";